import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { ApiContext } from '../../context/ApiContext';
import { Form, Col, Row, Table } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import Cookies from 'js-cookie'
import { StyleContext } from '../../context/StyleContext';
import { PermissoesContext } from '../../context/PermissoesContext';
import Select from 'react-select';

function ModalTrocarRole() {

    const { setModalTrocarRole, EditarRole, AdminUser, SupervisorUser, NomeUser, EmailUser, LeitorUser, Permissao, ListaArea, Areas, ListaAreaUsuario, AreaUsuario, UserId, setEdicaoUsuario, EdicaoUsuario } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const { MenuUsuario } = useContext(PermissoesContext)

    const [Admin, setAdmin] = useState(AdminUser)
    const [Supervisor, setSupervisor] = useState(SupervisorUser)
    const [Nome, setNome] = useState(NomeUser)
    const [Leitor, setLeitor] = useState(LeitorUser)
    const [permissoes, setPermissoes] = useState([])
    const [areasSelecionadas, setAreasSelecionadas] = useState([]);

    const role = Cookies.get('Role')

    useEffect(() => {
        setPermissoes(
            MenuUsuario.map((item) => ({
                usuarioId: item.usuarioId,
                menuKey: item.menu.key,
                edicao: item.edicao,
                somenteLeitura: item.somenteLeitura
            }))
        )
    }, [MenuUsuario])

    const handleChange = (e, menuKey, tipo) => {
        const checked = e.target.checked;

        const updatedPermissoes = permissoes.map((perm) => {
            if (perm.menuKey !== menuKey) return perm;

            if (tipo === "edicao") {
                return {
                    ...perm,
                    edicao: checked,
                    somenteLeitura: checked ? true : perm.somenteLeitura
                };
            }

            if (tipo === "somenteLeitura") {
                if (perm.edicao && !checked) {
                    return perm;
                }

                return {
                    ...perm,
                    somenteLeitura: checked
                };
            }

            return perm;
        });

        setPermissoes(updatedPermissoes);
    };

    useEffect(() => {
        ListaArea()
        ListaAreaUsuario(UserId)
    }, [])


    const areasOptions = Areas && Areas.map((org) => ({
        label: org.descricao,
        value: org.key,
    }));

    const handleAreasEditChange = (selectedOptions) => {
        setAreasSelecionadas(selectedOptions);

        const novasAreas = (selectedOptions || []).map((option) => ({
            areaKey: option.value,
            usuarioId: UserId,
        }));

        setEdicaoUsuario((prev) => ({
            ...prev,
            areas: novasAreas,
        }));
    };

    useEffect(() => {
        if (AreaUsuario && AreaUsuario.length > 0) {
            const selecionadas = AreaUsuario.map((item) => ({
                label: item?.descricao,
                value: item?.key,
            }));
            setAreasSelecionadas(selecionadas);

            const novasAreas = AreaUsuario.map((item) => ({
                areaKey: item?.key,
                usuarioId: UserId,
            }));

            setEdicaoUsuario((prev) => ({
                ...prev,
                areas: novasAreas,
            }));
        }
    }, [AreaUsuario]);

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <div>
                        <h1 className="h1-modal">Editar usuário</h1>
                    </div>
                    <div className="btn-close-modal" onClick={() => setModalTrocarRole(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div className="modal-content">
                    <Row>
                        <Col>
                            <Form.Group className="mb-3 mt-2">
                                <Form.Label>Nome</Form.Label>
                                <Form.Control defaultValue={NomeUser} onChange={(e) => setNome(e.target.value)} name="nome" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3 mt-2">
                                <Form.Label>E-mail</Form.Label>
                                <Form.Control defaultValue={EmailUser} name="email" readOnly />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>Áreas</Form.Label>
                                <Select
                                    value={areasSelecionadas}
                                    placeholder="Selecione"
                                    isMulti
                                    name="colors"
                                    options={areasOptions}
                                    onChange={handleAreasEditChange}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3 mt-2">
                        <Form.Label>Função</Form.Label>
                        <div>
                            {['checkbox'].map((type) => (
                                <div key={`inline-${type}`} className="mb-3">
                                    {role == "admin" &&
                                        <Form.Check
                                            inline
                                            label="Administrador de usuários"
                                            name="admin"
                                            type={type}
                                            id={`inline-${type}-2`}
                                            onChange={(e) => setAdmin(e.target.checked)}
                                            defaultChecked={AdminUser ? true : false}
                                        />
                                    }
                                </div>
                            ))}
                        </div>
                    </Form.Group>
                    <Table bordered size="sm" className="align-middle titulo-fases" style={{ width: "50%" }}>
                        <thead>
                            <tr>
                                <th className="text-start"></th>
                                <th>Edição</th>
                                <th>Leitura</th>
                            </tr>
                        </thead>
                        <tbody>
                            {MenuUsuario.map((menuItem, index) => {
                                const permissao = permissoes.find((p) => p.menuKey === menuItem.menu.key) || {};
                                return (
                                    <tr key={index}>
                                        <td className="text-start">{menuItem.menu.descricao}</td>
                                        <td style={{ textAlign: "center" }}>
                                            <Form.Check
                                                inline
                                                name={`edicao-${menuItem.menu.key}`}
                                                type="checkbox"
                                                id={`edicao-${menuItem.menu.key}`}
                                                onChange={(e) => handleChange(e, menuItem.menu.key, 'edicao')}
                                                checked={permissao.edicao || false}
                                            />
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                            <Form.Check
                                                inline
                                                name={`somenteLeitura-${menuItem.menu.key}`}
                                                type="checkbox"
                                                id={`somenteLeitura-${menuItem.menu.key}`}
                                                onChange={(e) => handleChange(e, menuItem.menu.key, 'somenteLeitura')}
                                                checked={permissao.somenteLeitura || false}
                                                disabled={permissao.edicao}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalTrocarRole(false)}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar} onClick={() => EditarRole(Admin, Supervisor, Leitor, Nome, permissoes)}>Salvar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalTrocarRole